export default __webpack_public_path__ + "static/media/ananyaBig-1.08d1055e.png";